import { VideoProviderEnum } from 'features/contents';
import { LiveStatusEnum } from 'features/lives';

import { TeacherInfo } from './TeacherInfo';

export enum LiveMeetingAttendanceConfirmationStatusEnum {
  NotNeeded = 0,
  Pending = 1,
  Confirmed = 2,
  Expired = 3,
}

export enum LiveMeetingAttendanceConfirmationTypeEnum {
  Unspecified = 0,
  InputConfirmationCode = 1,
  ClickedOnConfirmationUrl = 2,
}

export interface LiveVideoCard {
  uuid?: string;
  slug?: string;
  date?: string;
  name: string;
  guests?: string;
  teacher?: TeacherInfo;
  imageUrl: string;
  liveStatus?: LiveStatusEnum;
  rescheduledDate?: string;
  videoProvider?: VideoProviderEnum;
  externalLiveMeetingInvitationUrl: string;
  durationSeconds?: number;
  showDate: boolean;
  productSlug?: string;
  productUuid?: string;
  productName?: string;
  productClassUuid?: string;
  productClassDescription?: string;

  liveMeetingUuid?: string;
  attendanceConfirmationStatus: LiveMeetingAttendanceConfirmationStatusEnum;
  attendanceConfirmationAt?: string;
  attendanceConfirmationCodeExpiresAt?: string;
}
